// KPI hücre notu iş parçacığı — tek kopya kaynağı (portal yetki modeli v2 Dalga 3, spec §6/§8.4/§8.5;
// RK36 kalıbı). `kpi-ui.ts` `KPI_COPY.portal.notes` / `KPI_COPY.notes` /
// `KPI_COPY.scopeTotalReadonlyHint` olarak buradan besler. e2e spec 15/15b `COPY.notes` ELLE EŞLENİK
// kopyadır — birini değiştirince diğerini de güncelle.
// Müşteri yüzeyi (`portal`) metinlerinde "AI", "üretim", "danışman notu" geçmez (spec 09/15b
// `toHaveCount(0)` iddiaları; "Danışman yanıtı" ve "Danışmanınıza not" bu kalıba takılmaz).

export const KPI_NOTES_COPY = {
  portal: {
    title: "Notlar",
    consultantReply: "Danışman yanıtı:",
    placeholder: "Danışmanınıza not yazın",
    send: "Gönder",
    empty: "Bu hücrede henüz not yok",
    /** Formül girdisi müşteriye kapalıysa ham kod/etiket yerine bu metin görünür (sızıntı yok). */
    hiddenInput: "erişiminiz olmayan gösterge",
    // ─── arayüz yardımcı metinleri ───
    you: "Siz",
    clientFallback: "Müşteri",
    sent: "Notunuz danışmanınıza iletildi",
    loading: "Notlar yükleniyor…",
    loadFailed: "Notlar yüklenemedi",
    retry: "Tekrar dene",
    sendFailed: "Not gönderilemedi",
    /** 403 — hücre görünmüyor ya da erişim kalktı; sakin, suçlayıcı olmayan metin. */
    forbidden: "Bu hücreye erişiminiz yok",
    close: "Kapat",
    cancel: "İptal",
    addNote: "Not ekle",
    badgeLabel: (n: number, unread: boolean): string =>
      unread ? `${n.toString()} not · okunmamış yanıt var` : `${n.toString()} not`,
  },
  internal: {
    title: "Notlar",
    reply: "Yanıtla",
    pendingTitle: (n: number): string => `Yanıt bekleyen notlar (${n.toString()})`,
    // ─── arayüz yardımcı metinleri ───
    placeholder: "Yanıtınızı yazın",
    sent: "Yanıtınız iletildi",
    empty: "Bu hücrede henüz not yok",
    clientFallback: "Müşteri",
    consultantFallback: "Danışman",
    you: "Siz",
    loading: "Notlar yükleniyor…",
    loadFailed: "Notlar yüklenemedi",
    retry: "Tekrar dene",
    sendFailed: "Not gönderilemedi",
    forbidden: "Bu hücreye erişim yok",
    close: "Kapat",
    cancel: "İptal",
    addNote: "Not ekle",
    badgeLabel: (n: number, unread: boolean): string =>
      unread ? `${n.toString()} not · okunmamış müşteri notu var` : `${n.toString()} not`,
    /** Onay kuyruğu / Özet satırı: hücredeki son müşteri notu + thread bağlantısı */
    latestClientNote: "Müşteri notu",
    openThread: (n: number): string => `Notları aç (${n.toString()})`,
    pendingEmpty: "Yanıt bekleyen not yok",
    pendingHint: "Son mesajı müşteriden gelen hücreler.",
    threadFor: (label: string, year: number): string => `${label} · ${year.toString()}`,
  },
  scopeTotalReadonlyHint:
    "Kapsamınızdaki işletmeler toplamı yalnız görüntülenir — değer girmek için bir işletme seçin.",
} as const;
